import {
  MIN_STAMP_POSITION, MAX_STAMP_POSITION, PERCENT_RATE
} from '../../../../constants/timeProgressBar';

export const getStampPosition = (
    targetTime: number, max: number, currentTime: number
): number => {
  const maxValue = currentTime > max ? currentTime : max;
  const position = Math.round(targetTime / maxValue * PERCENT_RATE);

  if (position < MIN_STAMP_POSITION) {
    return MIN_STAMP_POSITION;
  }

  if (position > MAX_STAMP_POSITION) {
    return MAX_STAMP_POSITION;
  }

  return position;
};
